import { useEffect } from "react";

export default function useAutoUpdate(checkInterval = 60000) {
  useEffect(() => {
    const check = async () => {
      try {
        const response = await fetch("/index.html", { cache: "no-store" });
        const text = await response.text();
        const match = text.match(/main\.(\w+)\.js/);
        const newHash = match ? match[1] : null;
        const oldHash = localStorage.getItem("build_hash");

        if (newHash && oldHash && newHash !== oldHash) {
          console.log("🔄 New build detected, reloading...");
          window.location.reload(true); // auto-refresh
        }

        if (newHash) {
          localStorage.setItem("build_hash", newHash);
        }
      } catch (err) {
        console.error("Version check failed", err);
      }
    };

    check();
    const interval = setInterval(check, checkInterval);

    return () => clearInterval(interval);
  }, [checkInterval]);
}
